import { createReducer } from 'typesafe-actions'
import { ActionTypes } from '../types'
import { setFiats } from '../actions'

export type FiatState = {
  data: string[]
}

export const initialState: FiatState = {
  data: [],
}

export const fiat = createReducer<FiatState, ActionTypes>(initialState).handleAction(
  setFiats,
  (state: FiatState, { payload }) => ({
    data: Array.from(new Set((payload || []).map((c) => (c || '').toUpperCase().trim()))),
  }),
)
